import { useDispatch, useSelector } from "react-redux"

import { AppDispatch, persistor, resetAllState, RootState } from "@/store/store"
import { setUser } from "@/store/user/userSlice"
import { useLazyGetMeQuery } from "@/store/userAPI"
import { clearAuthCookies } from "@/utils/authUtils"

export const useUser = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector((state: RootState) => state.user)
  const [getMe] = useLazyGetMeQuery()

  const fetchUser = async () => {
    const data = await getMe().unwrap()
    if (!data.success) throw new Error("Session could not be verified")
    dispatch(setUser(data.user))
    return data
  }

  /**
   * Clears all frontend state on logout:
   * 1. Removes auth cookies so the next request is unauthenticated.
   * 2. Resets every Redux slice (incl. RTK Query cache) to its initial state.
   * 3. Purges the redux-persist localStorage snapshot so stale data cannot
   *    re-hydrate when the next user logs in or when the tab is refreshed.
   */
  const logout = () => {
    clearAuthCookies()
    dispatch(resetAllState())
    persistor.purge()
  }

  return {
    user,
    fetchUser,
    logout,
  }
}
